import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import echarts from 'echarts'
import "echarts-liquidfill"
import ElementUI from 'element-ui'
// import VueDragResize from 'vue-drag-resize'
// import splitPane from 'vue-splitpane'
import 'element-ui/lib/theme-chalk/index.css'
import '@/assets/baseStyle/baseStyle.css'
import '@/assets/iconfont/iconfont.css'

Vue.use(ElementUI)

import '@/icons' // icon
// Vue.component('vue-drag-resize', VueDragResize)
// Vue.component('split-pane', splitPane)

const origin = window.origin
// window.devDownloadIp = 'http://218.23.36.18:11001/8003/'
// window.devDownloadIp = 'http://114.215.146.204:8000/'
window.devDownloadIp = origin + '/cost/'
// window.devDownloadIp = 'http://112.31.81.178/CostBuild/'
// window.devDownloadIp = 'http://172.16.0.108:8000/'
// 帮助里视频地址
window.playUrl = 'https://www.dxcjpt.com/filePreview/'

import Router from 'vue-router'
const originalPush = Router.prototype.push
const originalReplace = Router.prototype.replace

Router.prototype.push = function push(location, onResolve, onReject) {
    if (onResolve || onReject)
        return originalPush.call(this, location, onResolve, onReject)
    return originalPush.call(this, location).catch(err => err)

}

Router.prototype.replace = function replace(location, onResolve, onReject) {
    if (onResolve || onReject)
        return originalReplace.call(this, location, onResolve, onReject)
    return originalReplace.call(this, location).catch(err => err)

}

const sessionStorage = window.sessionStorage
const localStorage = window.localStorage
Vue.prototype.$echarts = echarts

window.loadingClues = '加载中' // 全局loading提示语

router.beforeEach((to, from, next) => {
    if (to.path === "/transit") {
        document.getElementsByTagName("title")[0].innerText = '鼎信材价平台'
        next({ path: "/login" })
    } else {
        document.getElementsByTagName("title")[0].innerText = '鼎信材价平台'
    }
    if (!localStorage.getItem('access_token')) {
        if (to.path !== "/login" && to.path !== "/transit" && to.path !== "/guide" && to.path !== "/mapAnHui") {
            next({ path: "/login" })
        } else {
            next()
        }
    } else {
        next()
    }
})

Vue.prototype.$sessionStorage = {
    getItem: (name) => {
        return sessionStorage.getItem(name)
    },
    setItem: (name, val) => {
        sessionStorage.setItem(name, val)
    }
}

// 深拷贝
Vue.prototype.$deepCopy = function (source, type) {
    let sourceCopy

    switch (type) {
        case "Array":
            sourceCopy = []
            break
        case "Object":
            sourceCopy = {}
            break
        default:
            break
    }

    for (var item in source) {
        switch (Object.prototype.toString.call(source[item])) {
            case "[object Array]":
                sourceCopy[item] = source[item]
                break;
            case "[object object]":
                sourceCopy[item] = this.$deepCopy(source[item], "object")
                break
            default:
                sourceCopy[item] = source[item]
                break
        }
    }

    return sourceCopy
}

// 数组检查
Vue.prototype.$ArrayCheck = function (array) {
    if (Object.prototype.toString.call(array) === '[object Array]') {
        if (array.length > 0) {
            return true
        } else {
            return false
        }
    } else {
        return false
    }
}

// localStorage
Vue.prototype.$localStorage = {
    get: (name) => {
        if (localStorage) {
            if (name == null || typeof (name) === "undefined" || name === "undefined" || name === "") {
                return ''
            } else {
                return localStorage.getItem(name)
            }
        }
    },
    set: (name, val) => {
        if (localStorage) {
            localStorage.setItem(name, val)
        }
    },
    clear: () => {
        if (localStorage) {
            localStorage.clear()
        }
    },
    remove: (name) => {
        if (localStorage) {
            localStorage.removeItem(name)
        }
    }
}

// 引入函数库
import XEUtils from 'xe-utils'
Vue.prototype.$utils = XEUtils

// 引入 HTML2canvas
import html2canvas from 'html2canvas';
Vue.prototype.$html2canvas = html2canvas

import print from './utility/print'
Vue.use(print)
console.log(process.env.NODE_ENV)

new Vue({
    el: '#app',
    router,
    store,
    components: { App },
    template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js